import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {DialogComponent} from '../dialog/dialog.component';
import {MyButtonComponent} from 'src/app/shared/components/buttons/my-button/my-button.component';
import {ButtonProperty} from 'src/app/core/models/button.model';
import {MatDialogRef} from '@angular/material/dialog';


@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [
    DialogComponent,
    MyButtonComponent
  ],
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogComponent {
  @Input() title?: string
  @Input() message?: string
  @Input() acceptButton: ButtonProperty = {
    color: 'primary',
    label: 'Ok',
    raised: true
  }
  @Input() rejectButton: ButtonProperty = {
    color: 'basic',
    label: 'Annulla'
  }

  constructor(private dialogRef: MatDialogRef<ConfirmDialogComponent>) {
  }

  onAcceptButtonClick() {
    this.dialogRef.close(true);
  }

  onRejectButtonClick() {
    this.dialogRef.close(false);
  }
}
